import {useEffect, useState} from "react";
import {useAuth} from "../../../providers/AuthenticationProvider";
import {useNavigate} from "react-router-dom";
import {Form, Message} from "semantic-ui-react";
import {useWeatherStation} from "../../../providers/WeatherStationProvider";
import '../WeatherStations.css';

const WEB_PAGE = 'Weather Stations'
export const WeatherStationCreate = () => {
    const { checkAuth, getUserType } = useAuth();
    const navigate = useNavigate();
    const { createWeatherStation } = useWeatherStation();
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [name, setName] = useState('');
    const [usaf, setUsaf] = useState('');
    const [wban, setWban] = useState('');
    const [icao, setIcao] = useState('');
    
    useEffect(() => {
        if(checkAuth(getUserType(), WEB_PAGE)) {
            navigate('/');
        }
    })
    
    const handleSubmit = e => {
        e.preventDefault();
        setErrors([]);
        
        if (!name.trim() || !usaf.trim() || !wban.trim() || !icao.trim()) {
            setErrors(['All fields are required and must not be empty.']);
            return;
        }
        
        setLoading(true);
        createWeatherStation(name.trim(), usaf.trim(), wban.trim(), icao.trim())
            .then(res => {
                setLoading(false);
                navigate('/weather-stations');
            })
            .catch(err => {
                if (err?.response?.data?.errors) {
                    setErrors(
                        err.response.data.errors.map(error => {
                            return error.description;
                        })
                    );
                } else {
                    setErrors(['Failed to create a new weather station.'])
                }
                setLoading(false);
            })
    }
    
    return (
        <div>
            <div className="pageHeader">
                <h1>Create a Weather Station</h1>
            </div>
            <Form onSubmit={handleSubmit} error={errors.length > 0} style={{ maxWidth: '600px' }}>
                <Form.Group>
                    <Form.Input
                        width={16}
                        label="Name"
                        onChange={e => {
                            setName(e.target.value);
                        }}
                        type="text"
                        required
                    />
                </Form.Group>
                <Form.Group widths={3}>
                    <Form.Input
                        label="USAF"
                        onChange={e => {
                            setUsaf(e.target.value);
                        }}
                        type="text"
                        required
                    />
                    <Form.Input
                        label="WBAN"
                        onChange={e => {
                            setWban(e.target.value);
                        }}
                        type="text"
                        required
                    />
                    <Form.Input
                        label="ICAO"
                        onChange={e => {
                            setIcao(e.target.value);
                        }}
                        type="text"
                        required
                    />
                </Form.Group>
                {errors.length > 0 ? (
                    <Form.Group >
                        <Message error list={errors}/>
                    </Form.Group>
                ) : null}
                <Form.Group>
                    <Form.Button
                        type='submit'
                        loading={loading}
                        size='large'
                        color='blue'
                        style={{ marginTop: '32px' }}
                    >
                        Submit
                    </Form.Button>
                    <Form.Button
                        size='large'
                        style={{ marginTop: '32px' }}
                        onClick={(e) => {
                            e.preventDefault();
                            navigate('/weather-stations')
                        }}
                    >
                        Cancel
                    </Form.Button>
                </Form.Group>
            </Form>
        </div>
    )
}
